import { render, staticRenderFns } from "./ManagePatientAddConfirm.vue?vue&type=template&id=387eac75&scoped=true&"
import script from "./ManagePatientAddConfirm.vue?vue&type=script&lang=ts&"
export * from "./ManagePatientAddConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387eac75",
  null
  
)

export default component.exports